import { Link, useSearchParams } from 'react-router-dom'
import { sok } from '../lib/sok'
import { useSidTitel } from '../lib/seo'

/** Sökresultatsidan (/sok?q=…) — sökikonen i huvudmenyn länkar hit, och
 *  resultatet uppdateras direkt medan man skriver (ingen Sök-knapp behövs,
 *  men Enter/submit fungerar också). Sökningen körs helt i webbläsaren (se
 *  lib/sok.ts), så resultatet visas utan nätverksanrop — och frågan speglas
 *  alltid i URL:en (?q=), som är sajtens SearchAction-mål (schema.org, se
 *  WebSite-posten i entry-server.tsx) och måste fungera på riktigt.
 *  noindex i entry-server.tsx: sidans innehåll varierar med frågan och ska
 *  inte konkurrera med de riktiga sidorna i sökmotorernas index. */
export default function SokSida() {
  const [params, setParams] = useSearchParams()
  const fraga = params.get('q') ?? ''
  useSidTitel(fraga ? `Sök: ${fraga}` : 'Sök')

  const uppdatera = (varde: string) => {
    setParams(varde ? { q: varde } : {}, { replace: true })
  }

  const resultat = fraga.trim() ? sok(fraga) : []

  return (
    <div className="wrap">
      <section className="hero">
        <h1>Sök</h1>
        <form className="sokform" onSubmit={(e) => e.preventDefault()} role="search">
          <input
            type="search"
            value={fraga}
            onChange={(e) => uppdatera(e.target.value)}
            placeholder="Sök i kapitel, begrepp, modeller och lärarmaterial …"
            aria-label="Sökord"
            autoFocus
          />
          <button type="submit" className="knapp knapp-primar">
            Sök
          </button>
        </form>
      </section>

      {fraga.trim() && (
        <p className="sektionsingress">
          {resultat.length === 0
            ? `Inga träffar på ”${fraga}”.`
            : `${resultat.length} träff${resultat.length === 1 ? '' : 'ar'} på ”${fraga}”.`}
        </p>
      )}

      <ul className="sokresultat">
        {resultat.map((r) => (
          <li key={r.url}>
            <Link to={r.url}>
              <span className="sokresultat-typ">{r.typ}</span>
              <span className="sokresultat-titel">{r.titel}</span>
              <span className="sokresultat-beskrivning">{r.beskrivning}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
